import React, {useEffect} from 'react';
import './CookieModal.css';

function CookieModal({setIsVisible}) {

    const handleClose = (e) => {
        setIsVisible(false);
        localStorage.setItem("THIS_IS_COOKIEEEEE", true)
    }

    useEffect(() => {
        document.body.classList.add("no-scroll")
        return()=>{
            document.body.classList.remove("no-scroll")
        }
    }, []);

    return (
        (
            <div className="modal-container">
                <div className="modal-content">
                    <h3>Predvoľby súborov cookie</h3>
                    <p>
                    Súbory cookie používame na poskytovanie základných funkcií stránky a na zlepšenie vašich skúseností.
                    </p>
                    <div className="options">
                        <div className="option1">
                            <input type="checkbox" defaultChecked disabled={true} />
                            <label>Potrebné systémové súbory cookie</label>
                        </div>
                    </div>
                    <button className="close-button-all" onClick={handleClose}>Prijať</button>
                </div>
            </div>
        )
    );
}

export default CookieModal;
